var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd",
    clipPath: "url(#ExternalLink_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.243 8.279a.694.694 0 0 0-.693.692v9.658H1.379V3.45h9.657a.69.69 0 0 0 .664-.714.687.687 0 0 0-.664-.665H.693A.69.69 0 0 0 0 2.757v16.55c0 .379.307.693.693.693h16.55a.693.693 0 0 0 .693-.693V8.964a.693.693 0 0 0-.693-.693z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.308 0h-4.136a.69.69 0 0 0-.665.714.687.687 0 0 0 .665.665h2.471L8.48 10.543a.69.69 0 0 0 0 .978.69.69 0 0 0 .979 0l9.164-9.164V4.83c-.014.378.285.7.664.714s.7-.286.714-.664V.693A.69.69 0 0 0 19.308 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ExternalLink_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgExternalLink;